module.exports = __webpack_public_path__ + "img/service-white-icon4.56badbd4.png";